import { commonStyles } from 'features/cart/styles';
import { ICartEntry, MinimalCartEntryType } from 'features/cart/types';
import { calculateEntryChildrenPrice, isIncentiveOrCombo } from 'features/cart/utils';
import { useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import Picture from 'components/picture';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants/primitives';

const ModifiersNames = ({ modifiersNames }: { modifiersNames: string }) => {
  const { formatMessage } = useIntl();
  if (!modifiersNames) {
    return null;
  }
  return (
    <Text style={commonStyles.cartEntryBody}>
      <Text style={commonStyles.cartEntryItemName}>{formatMessage({ id: 'yourWay' }) + ' '}</Text>
      <Text>{modifiersNames}</Text>
    </Text>
  );
};

const CartItem = ({
  cartEntry,
  isSingleItem = false,
}: {
  cartEntry: ICartEntry;
  isSingleItem?: boolean;
}) => {
  const { formatPriceWithSign } = useUIContext();
  const modifiersNames = cartEntry.children.map(child => child.name).join(', ');
  const modifiersPrice = calculateEntryChildrenPrice(cartEntry);
  const priceLabel = isSingleItem
    ? formatPriceWithSign(modifiersPrice)
    : formatPriceWithSign(modifiersPrice + (cartEntry.price?.amount ?? 0));
  if (cartEntry.type !== MinimalCartEntryType.item) {
    return null;
  }

  return (
    <View style={styles.item}>
      <Picture
        size="$12"
        alt={cartEntry.image.locale?.imageDescription || ''}
        image={cartEntry.image}
      />
      <View style={styles.itemDetails}>
        <Text numberOfLines={2} ellipsizeMode="tail" style={commonStyles.cartEntryItemName}>
          {cartEntry.name}
        </Text>
        {priceLabel && <Text style={commonStyles.cartEntryBody}>{priceLabel}</Text>}
        <ModifiersNames modifiersNames={modifiersNames} />
      </View>
    </View>
  );
};

export const CartEntryBody = ({ cartEntry }: { cartEntry: ICartEntry }) => {
  return (
    <View style={{ flexDirection: 'column' }}>
      {isIncentiveOrCombo(cartEntry) &&
        cartEntry.children.map(child => (
          <CartItem key={child.cartId ?? child.id} cartEntry={child} />
        ))}
      {!isIncentiveOrCombo(cartEntry) && (
        <CartItem key={cartEntry.cartId} cartEntry={cartEntry} isSingleItem />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  item: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center',
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
  },
  itemDetails: {
    flexDirection: 'column',
    gap: 4,
    flex: 1,
    minWidth: 0,
  },
});
